import React from "react";

export default function Footer() {
  return (
    <footer className="footer-rectangle">
      <div className="footer-grid">

        <div>
          <h3>Contact</h3>
          <p>DirectSchoon</p>
          <p>KVK: 91347254</p>
          <p>BTW: 865625633B01</p>
          <p>📍 ODIJK, NEDERLAND</p>
          <p>📬 3984MB</p>
          <p>📞 +3164146169</p>
          <p>✉️ info@directshoon-diensten.nl</p>
        </div>

        <div className="footer-section">
            <h3>Werken bij Directschon</h3>
            <p>👉 Solliciteer nu</p>
            <p>👉 Uren indienen</p>
            <p>👉 Vakantie aanvragen</p>
            <p>👉 Materiaalbestellingen-team</p>
        </div>

        <div className="footer-section">
            <h3>Ga naar :</h3>
            <p>Zakeljik</p>
            <p>Privé</p>
            <p>Wie zijn wij?</p>
            <p>Contact</p>
        </div>

        <div className="footer-section">
            <h3>Steden</h3>

            <div className="city-grid">
              <span>Utrecht</span>       <span>Neugein</span>
              <span>Amersfoort</span>    <span>En bois</span>
              <span>Amsterdam</span>     <span>Zeist</span>
              <span>Rotterdam</span>     <span>Le Bilt</span>
              <span>Maarssen</span>      <span>Bilthoven</span>
              <span>Le Meern</span>      <span>Bunnik</span>
              <span>IJsselstein</span>   <span>Woerden</span>
            </div>
        </div>

        <div className="footer-section">
            <h3>Volg ons</h3>

            <div className="social-grid">
              <div className="social-icon">F</div>
              <div className="social-icon">I</div>
              <div className="social-icon">in</div>
              <div className="social-icon">▶</div>
            </div>
        </div>

      </div>

      <div className="footer-bottom">
          © 2026 DirectSchoon │ Privacyverklaring │ Cookiebeleid │ Technische support │ Algemene voorwaarden
      </div>
    </footer>
  );
}
